import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import i18n from "utils/I18n";
import { getLevelRenewTime } from "../../utils/DateTimeUtils";
import { getTranslationField } from "../../utils";
import "./LevelHasRetainInfo.scss";


const LevelHasRetainInfo = ({
  language,
  renewDate,
  currentLevelData,
  showLevelHasRetain,
}) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(showLevelHasRetain);

  const currentLevelName = getTranslationField(currentLevelData, "levelName", language);

  useEffect(() => {
    setShow(showLevelHasRetain);
  }, [showLevelHasRetain]);

  const closeRetainInfo = () => {
    setShow(false)
    dispatch({ type: 'users/closeRetainInfo' });
  };

  if (!show) {
    return null;
  };

  return (
    <div className="level-has-retain-info-container d-flex flex-column">
      <div className="level-has-retain-info-title-container d-flex flex-row subheading">
        <span className="level-has-retain-info-title">{i18n.t("retainTheMembership")}</span>
        <div className="level-has-retain-info-close-button-container" onClick={closeRetainInfo}>
          <img className="level-has-retain-info-close-button" alt="icon" src={"/profile/close.png"} />
        </div>
      </div>

      <div className="level-has-retain-info-content-container d-flex flex-row tag-menu-1">
        <div className="level-has-retain-info-tick-icon-container">
          <img className="level-has-retain-info-tick-icon" alt="icon" src={"/profile/retainLevel/retainSuccess.png"} />
        </div>
        <span className="level-has-retain-info-content">
          {i18n.t('levelHasRetain', {
            retainLevelName: currentLevelName,
            retainDate: getLevelRenewTime(renewDate),
          })}
        </span>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  language: state.users.language,
  renewDate: state.users.renewDate,
  currentLevelData: state.users.currentLevelData,
  showLevelHasRetain: state.users.showLevelHasRetain,
});

export default connect(mapStateToProps)(LevelHasRetainInfo);
